import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'topo-open-source-licenses',
    templateUrl: './open-source-licenses.component.html',
    styleUrls: ['./open-source-licenses.component.scss'],
    standalone: false
})
export class OpenSourceLicensesComponent implements OnInit {
  @Input()
  isActive = false;

  constructor() {}

  ngOnInit(): void {}

  close(): void {
    this.isActive = false;
  }
}
